export default __webpack_public_path__ + "static/media/first.977db27f.svg";